import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ViewCustomerService } from './view-customer.service';
import { environment as ENV } from '../../../environments/environment';

import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../admin-auth.service';
import * as moment from 'moment';
import { AdminService } from '../admin.service';
import { TokenServiceService } from 'app/token-service.service';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
import * as constants from '../../constant'
// import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { AddCoapplicantComponent} from '../add-coapplicant/add-coapplicant.component'

@Component({
  selector: 'wl-loader-dialog',
  template: `
    <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;">
    <i class="fa fa-spinner fa-pulse fa-2x fa-fw" style="color:#506c84;margin:0 auto;display:block;"></i>
      <p>Loading Data For the First time.. Please Wait..</p>
    </div>
  `
})
export class LoaderDialogComponent {
  message: string

  constructor(
    // public dialogRef: MatDialogRef<LoaderDialogComponent>
    public bsModalRef: BsModalRef,
  ) { }
}

@Component({
  selector: 'wl-view-customer',
  templateUrl: './view-landrecordupdatation.component.html',
  styleUrls: ['./view-landrecordupdatation.component.scss'],
  providers: [ViewCustomerService, AddCustomerService, AdminService],
})
export class ViewLandRecordUpdatationComponent implements OnInit {
  allUsers: Observable<any>;
  loading: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: string;
  role: string;
  limit: number = 10;
  offset: number = 0;

  userName: string;
  display: boolean;
  typeText: string;
  adminForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  pageId: any = 1;
  @ViewChild('date1') firstDate: ElementRef;
  showActions: boolean = true;
  selectedDate: string;
  showSelectedDate: boolean;
  currentDate: any;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showLandRecordDataTable: boolean = true;
  filter: string = '';

  constructor(
    private customer: ViewCustomerService,
    private dialog: MatDialog,
    private auth: AuthService,
    private router: Router,
    private jwt: JwtHelperService,
    private snackbar: MatSnackBar,
    private cust: AdminAuthService,
    private fb: UntypedFormBuilder,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private token: TokenServiceService,
    // public modalService: NgbModal
    private modalService: BsModalService,
    private advancedFilterService: AdvancedFilterService
  ) {
    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]+')])],
      email: [''],
      mobileNo: [''],

      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],
      employeeName: [''],
      employeeId: [''],
    });

    this.iscredCount = ENV.creditScoreSetting.credCount;
    if (ENV.creditScoreSetting.credMenu == 'shfl') {
      this.showOrHide = false;
    } else {
      this.showOrHide = true;
    }


      this.searchHolder = 'Search Applicant by Name / Customer ID';

      this.display = false;

  }
  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;

    if (this.isCoLogin()) {
      this.applyFilter(this.filter, 0, 1, 1);
      return;
    }

    this.page = 1;
    this.pageId = 1;
    this.loading = true;

    this.customer.getUsers(value, this.roleId, 0, 10).subscribe({
      next: (res) => {
        this.loading = false;

        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      error: (err) => {
        this.totalCount = 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        this.loading = false;
        throw err;
      },
    });
  }

  ngOnInit() {
    this.roleId = this.customer.getRoleId();
    if (this.isCoLogin()) {
      this.showLandRecordDataTable = false;
    }

    sessionStorage.removeItem('filterDateViewCustomerStart');
    sessionStorage.removeItem('filterDateViewCustomerEnd');
    this.maxDate = this.adminservice.getCurrentMonth();
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    this.currentDate = moment().format('YYYY-MM');
    var encrypted = sessionStorage.getItem('ubknknsviubi--131ss');
    console.log('decrypted ' + JSON.stringify(atob(encrypted)));

    if (window.addEventListener) {
      window.addEventListener('storage', this.storageListener, false);
    }

    this.role = sessionStorage.getItem('wzbvdsjvbbs');
    console.log('role ' + this.role);

    if (sessionStorage.getItem('filterDateViewCustomer')) {
      this.currentDate = moment(
        sessionStorage.getItem('filterDateViewCustomer'),
        'YYYY-MM-DD'
      ).format('YYYY-MM');
      let selected = this.currentDate;
      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      var another = months[+selected.split('-')[1] - 1];
      this.selectedDate = another + ', ' + selected.split('-')[0];
      this.showSelectedDate = true;
    }

    this.roleId = sessionStorage.getItem('getroleId');

    console.log('this.roleId ' + this.roleId);
    // getUsers("", roleId,offset/,limit)
    !this.isCoLogin() && this.getAllUsers('', this.roleId, 0, 10);

    this.placeHolder = ENV.placeHolderSetting.placeholder;

    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  storageListener() {
    // console.log("test")
    if (sessionStorage.getItem('submitted') && sessionStorage.getItem('submitted') == 'submitted') {
      // this.getAllUsers("", this.roleId, 0, 10);
      // this.ngOnInit()
      //   this.router.navigateByUrl('/ViewCustomerComponent', { skipLocationChange: true }).then(() => {
      //     this.router.navigate(['/ViewDashboardComponent']);
      // });
      window.location.reload();
    }
  }

  checkConsentStatus(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let fb = this.allUsers[i].consent_feedback_status;
      // console.log(fb)
      if (fb && fb == 'yes') {
        return fb.toUpperCase();
      } else if (fb && fb == 'no') {
        return fb.toUpperCase();
      } else if (fb && fb == 'pending') {
        return 'DNR';
      }
    }
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateViewCustomerStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateViewCustomerEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getUsersFilterDate('', this.roleId, 0, 10, this.dateInMs, this.endDateInMs, dateType)
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            this.allUsers = res.result.resultData ? res.result.resultData : '';
            this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
            this.totalPage = Math.ceil(this.totalCount / 10);
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  // submitDates() {
  //   if(this.firstDate.nativeElement.value <= this.maxDate && this.firstDate.nativeElement.value >= '2022-01'  ){
  //   this.showSelectedDate = true;
  //   console.log(this.firstDate.nativeElement.value);
  //   let selected = this.firstDate.nativeElement.value;
  //   var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  //   var another = months[+selected.split('-')[1] - 1];
  //   this.selectedDate = another + ', ' + selected.split('-')[0];
  //   console.log(this.firstDate.nativeElement.value);
  //   let filterDate = this.firstDate.nativeElement.value + '-01';
  //   sessionStorage.setItem('filterDateViewCustomer', filterDate)
  //   let date = new Date(filterDate);
  //   let dateInMs = date.getTime()
  //   this.customer.getUsersFilterDate("", this.roleId, 0, 10, dateInMs).subscribe(res => {
  //     console.log(res);
  //     if (res && res.result && res.result.resultData) {
  //       this.allUsers = res.result.resultData ? res.result.resultData : "";
  //       this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
  //       this.totalPage = Math.ceil(this.totalCount / 10);
  //     }
  //   })
  // }  else{
  //   this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
  // }

  // }

  getAllUsers(input, roleId, offset, limit) {
    this.loading = true;

    this.customer.getUsers(input, roleId, offset, limit).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
        }

        // if(res && res.count && res.result.count){
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);
        // }
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.loading = true;
    this.pageId = pageId;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
          this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
        }
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getRocCount() {
    this.customer.getRocCounts().subscribe((res) => {
      this.rocCount = res;
    });
  }

  retailCheck(isRetail) {
    this.snackbar.open('No Co-Applicant details found', 'OK', { duration: 2000 });
    console.log('retail...1 ', isRetail);
    // this.customer.isRetail = isRetail;
    if (isRetail == true) {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'tDrfsud25362htsjddh');
    } else {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'fFywshdssf7d9123dnd');
    }
  }

  getType(app, coapp, guarantor) {
    if (app) {
      return 'Applicant';
    } else if (coapp) {
      return 'Co-Applicant';
    } else {
      return 'Guarantor';
    }
  }

  openCust(
    applicantId,
    custName,
    custId,
    isApplicant,
    isValidated,
    custMail,
    isCan,
    paymentStatus,
    paymentId,
    isRetail
  ) {
    console.log('onGoToPage2 ' + custId + ' custName ' + custName + ' custMail ' + custMail);
    console.log(
      'isApplicant ' + isApplicant + '  isValidated ' + isValidated + ' isRetails ' + isRetail
    );
    sessionStorage.setItem('applicantId', applicantId);
    sessionStorage.setItem('wl-applicant-id', applicantId);

    switch (ENV.creditScoreSetting.credMenu) {
      case 'ubi':
        if (!isValidated && isApplicant && isCan) {
          // this.bsModalRef.content.onClose.subscribe(result => {
          //   console.log('results', result);
          // })

          // this.bsModalRef.hide();
          this.auth.userLogin('test@123', custId).subscribe((res) => {
            console.log('Login User', res);
            if (res && res.custId && res.custId.length > 0) {
              debugger;
              sessionStorage.setItem('lrOpenedFromAdmin', 'false');
              let stateCode = sessionStorage.getItem(constants.ROUTE_KEY);

              if (stateCode == constants.STATES.KA.KEY) {
                window.open(ENV.urlSetting.url + 'laas/land-records-ka');
              } else if (stateCode == constants.STATES.MP.KEY) {
                window.open(ENV.urlSetting.url + 'laas/land-records-mp');
              }else if(stateCode == constants.STATES.AD.KEY){
                window.open(ENV.urlSetting.url + 'laas/land-records-ap');
              }
            }
            // this.getAllUsers("", this.roleId, 0, 10);
          });

          // this.bsModalRef.hide();
        } else if (!isValidated && isApplicant && !isCan && !paymentStatus) {
          this.auth.userLogin('test@123', custId).subscribe((res) => {
            console.log('Login User', res);
            if (res && res.custId && res.custId.length > 0) {
              sessionStorage.setItem('lrOpenedFromAdmin', 'false');
              this.token.selectedstateCode.subscribe((value) => {
                console.log(value);

              });
              let stateCode = sessionStorage.getItem('wEnlw3OeU3');
              if (stateCode == 'KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y') {
                window.open(ENV.urlSetting.url + 'laas/land-records-ka');
              } else if (stateCode == 'xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1') {
                window.open(ENV.urlSetting.url + 'laas/land-records-mp');
              }else if (stateCode == "X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6") {
                  window.open(ENV.urlSetting.url + 'laas/land-records-ap');
              }
            }
            // this.getAllUsers("", this.roleId, 0, 10);
          });
          // });
        } else {
          // login can continue with flow
          this.auth.userLogin('test@123', custId).subscribe((res) => {
            console.log('Login User', res);
            if (res && res.custId && res.custId.length > 0) {
              window.open(ENV.urlSetting.url + 'laas');
            }
            
          });
        }

        break;

      default:
        window.open(ENV.urlSetting.url + 'login/' + custId);
        break;
    }
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateViewCustomer');
    sessionStorage.removeItem('filterDateViewCustomerStart');
    sessionStorage.removeItem('filterDateViewCustomerEnd');
    // console.log(this.activatedRoute.snapshot['_routerState'].url,'this.activatedRoute.snapshot');
    // this.ngOnInit();
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  isCoLogin() {
    if (this.roleId === '1') {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showLandRecordDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    try {
      this.customer.getLandRecord(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          let resultSet =
            response && response.result && response.result.resultData
              ? response.result.resultData
              : [];
          this.allUsers = resultSet;
          if (!resultSet.length) {
            this.noUserFound = 'Customer data not found';
          }
          this.totalCount =
            response && response.result && response.result.count ? response.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }
}
